import { useEffect, useRef } from 'react'
import useTableColumns from './useTableColumns'

const Column = ({ dataKey, children, id, ...opts }) => {
  const [columns, addColumn] = useTableColumns()
  const optsRef = useRef(opts)
  optsRef.current = opts

  useEffect(() => {
    const colId = id || dataKey
    if (columns.every(col => col.id !== colId)) {
      addColumn({
        id: colId,
        dataKey,
        cell: children,
        ...optsRef.current,
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColumn, columns, dataKey, id])

  return null
}

export default Column